// @flow

import type { State } from "@store/reducers";
import type { HierarchyAssignment } from "@modules/service/types";
import type {
  Referral,
  ReferralProcess,
  ReferralProcessesData,
} from "@modules/service/reducer/referrals/types";
import { validateHierarchyAssignmentSchema } from "./index";

// REFERRALS CRUD

export const referralProcessData = (state: State): ReferralProcessesData =>
  state.service.referrals.list;

export const getCurrentReferral = (state: State): ?ReferralProcess =>
  state.service.referrals.current;

export const getReferralDraft = (state: State): ?Referral => state.service.referrals.draft;

export const getReferralAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.referrals.assignments;

export const isReferralAssignmentsValid = (state: State): boolean => {
  const assignments = getReferralAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const hasActiveManualReferrals = (state: State): boolean => {
  const data = referralProcessData(state);
  return (data?.content || []).some(process => process.content && process.content.manualReferrals);
};

// REFERRALS SCHEMA

export const getReferralSchema = (state: State): Object | null => state.service.referrals.schema;
